<script setup lang="ts">
import { HgRadioButton } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { useAgencyProfilesStore } from '@/stores/agencyProfiles';
import { ListingType } from '@/types';

const { selectedListingType } = storeToRefs(useAgencyProfilesStore());
const agencyProfilesStore = useAgencyProfilesStore();

const { t } = useI18n();

const translate = (key: string): string => {
  return t(key) as unknown as string;
};

watch(selectedListingType, async () => await agencyProfilesStore.loadAgenciesCount());
</script>

<template>
  <div>
    <label :class="$style.headline">{{ t('agencyFocusText') }}</label>
    <HgRadioButton
      v-model="selectedListingType"
      :inputValue="ListingType.ANY"
      :label="translate('agencyFocus.any')"
      :class="$style.radio"
    />
    <HgRadioButton
      v-model="selectedListingType"
      :inputValue="ListingType.RENT"
      :label="translate('agencyFocus.rentProperties')"
      :class="$style.radio"
    />
    <HgRadioButton
      v-model="selectedListingType"
      :inputValue="ListingType.SALE"
      :label="translate('agencyFocus.saleProperties')"
      :class="$style.radio"
    />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.headline {
  padding: $space-150 0 $space-50 0 !important;

  @include label;
}

.radio {
  padding-right: $space-100;
}
</style>
